import React, {Component} from "react";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import PropTypes from "prop-types";
import ReactToPrint from "react-to-print";
import '../../styles/dailyChartGridStyles.css';
import $ from 'jquery';
import i18next from "i18next";

class DailyChartGrid extends Component {
    constructor(props) {
        super(props);

        this.refForPrint = React.createRef();

        let bgColors = ["rgb(255, 102, 0)", "rgb(255, 204, 153)"];

        let fixColorRE = (c) => c.replace("(", "\\(").replace(")", "\\)");

        this.backgroundColors = bgColors.map(c => ({
            color: c,
            reg: new RegExp("background-color: " + fixColorRE(c)),
            imp: new RegExp("background-color: " + fixColorRE(c) + " !important")
        }));
    }

    getNewStyle = (style) => {
        if (style) {
            let bc = this.backgroundColors.filter(re => style.search(re.reg) !== -1 && style.search(re.imp) === -1);
            if (bc.length > 0) {
                return style.replace(bc[0].reg, "background-color: " + bc[0].color + " !important");
            }
        }
        return style;
    };

    prepareForPrint = () => {
        //fix styles to print correct background in table cells
        let tdArr = $(this.refForPrint.current).find('.table td');
        for (let i = 0; i < tdArr.length; i++) {
            let td = $(tdArr[i]);
            let newStyle = this.getNewStyle(td.attr('style'));
            if (newStyle) {
                td.attr('style', newStyle);
            }
        }
    };

    render() {
        return (<>
            <ReactToPrint
                trigger={() => <button type="button"
                                       className="btn btn-regular -goahead mb-1">{i18next.t("Print")}</button>}
                content={() => this.refForPrint.current}
                documentTitle={this.props.title}
                /*    pageStyle={`@page {size: ${this.props.orientation}; ${(this.props.margin ? `margin: ${this.props.margin};` : '')}}`}*/
                onBeforeGetContent={this.prepareForPrint}
            />
            <div className="overflow-x-auto">
                <div className="dailyChartGridHolder" ref={this.refForPrint}>
                    <style type="text/css" media="print">{`@page {size: A4 ${this.props.orientation};
                    ${(this.props.margin ? `margin: ${this.props.margin};` : '')};  
                    }
                    .gridview {zoom: 90%;}                    
                    `}
                    </style>
                    {/* <style type="text/css" media="print">{`@page {size: ${this.props.orientation};}`}</style>*/}
                    {/* <div className="text-center mb-1 only-print"><h1>{this.props.title}</h1></div>*/}
                    <GridView dataItem={this.props.dataItem}
                              useItemStyle={true}
                              useOnlyDesktopMode={true}
                              allowHorizontalScrolling={false}
                              allowPagination={false}
                    />
                </div>
            </div>
        </>);
    }
}

DailyChartGrid.propTypes = {
    dataItem: PropTypes.object.isRequired,
    title: PropTypes.object,
    orientation: PropTypes.string,
    margin: PropTypes.string
}

DailyChartGrid.defaultProps = {
    orientation: 'auto'
};

export default DailyChartGrid;